(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-merch-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const truncate = (value, limit) => {
    const text = String(value ?? '').trim();
    if (text.length <= limit) {
      return text;
    }

    return `${text.slice(0, Math.max(0, limit - 1)).trimEnd()}…`;
  };

  document.querySelectorAll('[data-bb-merch-product]').forEach((root) => {
    const conceptField = root.querySelector('[data-custom-concept-field]');
    const briefField = root.querySelector('[data-custom-brief-field]');
    const workflowField = root.querySelector('[data-custom-workflow-field]');
    const status = root.querySelector('[data-custom-status]');
    const checkoutNote = root.querySelector('[data-custom-checkout-note]');
    const button = root.querySelector('.bb-merch-product__button--primary');
    const customCard = root.querySelector('[data-custom-brief-card]');
    const previewTitle = root.querySelector('[data-preview-title]');
    const previewDescription = root.querySelector('[data-preview-description]');
    const previewMeta = root.querySelector('[data-preview-meta]');
    const previewConceptPill = root.querySelector('[data-preview-concept-pill]');
    const previewBrandPill = root.querySelector('[data-preview-brand-pill]');
    const previewImage = root.querySelector('.bb-merch-product__preview-image');
    const previewArt = root.querySelector('[data-preview-art]');
    const previewSummary = root.querySelector('[data-preview-summary]');

    if (
      !conceptField ||
      !briefField ||
      !workflowField ||
      !status ||
      !checkoutNote ||
      !button ||
      !previewTitle ||
      !previewDescription ||
      !previewMeta ||
      !previewConceptPill ||
      !previewBrandPill ||
      !previewImage ||
      !previewArt ||
      !previewSummary
    ) {
      return;
    }

    const previewDefaults = {
      title: previewTitle.textContent.trim(),
      description: previewDescription.textContent.trim(),
      meta: previewMeta.textContent.trim(),
      conceptPill: previewConceptPill.textContent.trim(),
      brandPill: previewBrandPill.textContent.trim(),
    };
    const basePreviewSrc = root.dataset.previewBaseSrc || previewImage.currentSrc || previewImage.src || '';
    const genericPreviewSrc = root.dataset.previewGenericSrc || basePreviewSrc;
    const hydrogenPreviewSrc = root.dataset.hydrogenPreviewSrc || '';
    const brandLogoSrc = root.dataset.brandLogoSrc || '';

    const palette = [
      { accent: '#e8453c', glow: '#fff4f2' },
      { accent: '#c45a36', glow: '#fff6ef' },
      { accent: '#c98f2a', glow: '#fff8ea' },
      { accent: '#3d7ae8', glow: '#eff5ff' },
      { accent: '#3ca98b', glow: '#effaf6' },
      { accent: '#7a5ce6', glow: '#f4f1ff' },
    ];
    const compositeCache = new Map();
    const brandLogoCache = new Map();
    let previewRenderToken = 0;

    const svgEscape = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');

    const wrapLines = (value, limit, maxLines = 2) => {
      const words = String(value ?? '').trim().split(/\s+/).filter(Boolean);
      if (!words.length) {
        return [''];
      }

      const lines = [];
      let current = words.shift();

      while (words.length) {
        const next = words[0];
        const testLine = `${current} ${next}`;

        if (testLine.length > limit && current.length > 0) {
          lines.push(current);
          current = words.shift();
          continue;
        }

        current = testLine;
        words.shift();
      }

      if (current) {
        lines.push(current);
      }

      return lines.slice(0, maxLines);
    };

    const loadImage = (src) =>
      new Promise((resolve, reject) => {
        const image = document.createElement('img');
        image.decoding = 'async';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
      });

    const hexToRgb = (hex) => {
      const normalized = String(hex ?? '').replace('#', '').trim();
      if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
        return { r: 232, g: 69, b: 60 };
      }

      return {
        r: Number.parseInt(normalized.slice(0, 2), 16),
        g: Number.parseInt(normalized.slice(2, 4), 16),
        b: Number.parseInt(normalized.slice(4, 6), 16),
      };
    };

    const loadBrandLogo = async (brandColor) => {
      if (!brandLogoSrc) {
        return null;
      }

      const cacheKey = String(brandColor || '').toLowerCase();
      if (brandLogoCache.has(cacheKey)) {
        return brandLogoCache.get(cacheKey);
      }

      const source = await loadImage(brandLogoSrc);
      const cropTop = Math.max(0, Math.round(source.naturalHeight * 0.03));
      const cropBottom = Math.max(cropTop + 1, Math.round(source.naturalHeight * 0.77));
      const cropHeight = cropBottom - cropTop;
      const canvas = document.createElement('canvas');
      canvas.width = source.naturalWidth;
      canvas.height = cropHeight;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return null;
      }

      ctx.drawImage(source, 0, cropTop, source.naturalWidth, cropHeight, 0, 0, source.naturalWidth, cropHeight);
      const { r, g, b } = hexToRgb(brandColor);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] === 0) {
          continue;
        }

        data[i] = r;
        data[i + 1] = g;
        data[i + 2] = b;
      }

      ctx.putImageData(imageData, 0, 0);
      brandLogoCache.set(cacheKey, canvas);
      return canvas;
    };

    const drawRoundedRect = (ctx, x, y, width, height, radius) => {
      if (typeof ctx.roundRect === 'function') {
        ctx.beginPath();
        ctx.roundRect(x, y, width, height, radius);
        return;
      }

      const right = x + width;
      const bottom = y + height;
      const r = Math.min(radius, width / 2, height / 2);

      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(right, y, right, bottom, r);
      ctx.arcTo(right, bottom, x, bottom, r);
      ctx.arcTo(x, bottom, x, y, r);
      ctx.arcTo(x, y, right, y, r);
      ctx.closePath();
    };

    const drawBrandMark = async (ctx, centerX, topY, brandColor) => {
      const logo = await loadBrandLogo(brandColor);
      if (!logo) {
        ctx.fillStyle = brandColor;
        ctx.textAlign = 'center';
        ctx.font = '700 13px Georgia, "Times New Roman", serif';
        ctx.fillText('business', centerX, topY + 28);
        ctx.fillText('beaker', centerX, topY + 41);
        return;
      }

      const targetWidth = 112;
      const targetHeight = Math.max(1, Math.round((logo.height / logo.width) * targetWidth));
      ctx.drawImage(logo, Math.round(centerX - targetWidth / 2), Math.round(topY), targetWidth, targetHeight);
    };

    const buildPreviewGraphic = ({ number, symbol, tagline, brandPill, accent, glow }) => {
      const taglineLines = wrapLines(tagline, 24, 2);
      const brandLines =
        String(brandPill).trim().toLowerCase() === 'business beaker'
          ? ['business', 'beaker']
          : wrapLines(brandPill, 16, 2);
      const accentSafe = svgEscape(accent);
      const brandSafe = svgEscape('#E8453C');
      const glowSafe = svgEscape(glow);

      const taglineText = taglineLines
        .map((line, index) => `<tspan x="380" dy="${index === 0 ? 0 : 30}">${svgEscape(line)}</tspan>`)
        .join('');
      const brandText = brandLines
        .map((line, index) => `<tspan x="380" dy="${index === 0 ? 0 : 20}">${svgEscape(line)}</tspan>`)
        .join('');

      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 760 760" fill="none" role="img" aria-label="${svgEscape(`${number} ${symbol} preview`)}">
          <defs>
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="0" dy="18" stdDeviation="20" flood-color="#111111" flood-opacity="0.13"/>
            </filter>
            <radialGradient id="glow" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(150 152) rotate(22) scale(220 150)">
              <stop offset="0" stop-color="${glowSafe}" stop-opacity="0.86"/>
              <stop offset="1" stop-color="${glowSafe}" stop-opacity="0"/>
            </radialGradient>
          </defs>
          <rect x="20" y="20" width="720" height="720" rx="30" fill="#fbf8f5" stroke="#ece3dd" filter="url(#shadow)"/>
          <rect x="20" y="20" width="720" height="9" rx="4.5" fill="${brandSafe}"/>
          <circle cx="154" cy="158" r="152" fill="url(#glow)"/>
          <circle cx="604" cy="574" r="176" fill="${accentSafe}" fill-opacity="0.03"/>
          <text x="700" y="90" text-anchor="end" fill="${accentSafe}" font-family="Inter, Arial, sans-serif" font-size="30" font-weight="700" letter-spacing="0.04em">${svgEscape(number)}</text>
          <text x="380" y="346" text-anchor="middle" fill="#111111" font-family="Georgia, 'Times New Roman', serif" font-size="162" font-weight="700" letter-spacing="-0.08em">${svgEscape(symbol)}</text>
          <text x="380" y="478" text-anchor="middle" fill="#444444" font-family="Inter, Arial, sans-serif" font-size="24" font-weight="500">${taglineText}</text>
          <text x="380" y="618" text-anchor="middle" fill="${brandSafe}" font-family="Georgia, 'Times New Roman', serif" font-size="20" font-weight="700" letter-spacing="0.02em">${brandText}</text>
        </svg>
      `;

      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    };

    const renderCompositeMockup = async ({ number, symbol, title, tagline, brandPill, accent, glow }) => {
      const bagSrc = genericPreviewSrc || basePreviewSrc;
      const cacheKey = JSON.stringify({
        bagSrc,
        number,
        symbol,
        title,
        tagline,
        brandPill,
        accent,
        glow,
      });

      if (compositeCache.has(cacheKey)) {
        return compositeCache.get(cacheKey);
      }

      if (!bagSrc) {
        return '';
      }

      const bagImage = await loadImage(bagSrc);
      const canvas = document.createElement('canvas');
      const width = 1200;
      const height = Math.round(width * (bagImage.naturalHeight / bagImage.naturalWidth));
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return '';
      }

      ctx.drawImage(bagImage, 0, 0, width, height);

      const ambientWash = ctx.createRadialGradient(width * 0.5, height * 0.38, height * 0.08, width * 0.5, height * 0.44, height * 0.58);
      ambientWash.addColorStop(0, 'rgba(255,255,255,0)');
      ambientWash.addColorStop(1, 'rgba(17,17,17,0.03)');
      ctx.fillStyle = ambientWash;
      ctx.fillRect(0, 0, width, height);

      const cardW = Math.round(width * 0.225);
      const cardH = cardW;
      const cardX = Math.round((width - cardW) / 2);
      const cardY = Math.round(height * 0.6);
      const cardRadius = 16;
      const cardCenterX = cardX + cardW / 2;
      const cardCenterY = cardY + cardH / 2;

      ctx.save();
      ctx.translate(cardCenterX, cardCenterY);
      ctx.rotate(-0.01);
      ctx.translate(-cardCenterX, -cardCenterY);
      ctx.shadowColor = 'rgba(17,17,17,0.18)';
      ctx.shadowBlur = 24;
      ctx.shadowOffsetY = 16;
      drawRoundedRect(ctx, cardX, cardY, cardW, cardH, cardRadius);

      const cardFill = ctx.createLinearGradient(cardX, cardY, cardX + cardW, cardY + cardH);
      cardFill.addColorStop(0, '#fffdfb');
      cardFill.addColorStop(1, '#f7f1ec');
      ctx.fillStyle = cardFill;
      ctx.fill();
      ctx.restore();

      drawRoundedRect(ctx, cardX, cardY, cardW, cardH, cardRadius);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(17,17,17,0.08)';
      ctx.stroke();

      const innerHighlight = ctx.createLinearGradient(cardX, cardY, cardX + cardW, cardY + cardH);
      innerHighlight.addColorStop(0, 'rgba(255,255,255,0.18)');
      innerHighlight.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = innerHighlight;
      drawRoundedRect(ctx, cardX + 1, cardY + 1, cardW - 2, cardH - 2, cardRadius - 1);
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(cardX + 16, cardY + 10);
      ctx.lineTo(cardX + cardW - 16, cardY + 10);
      ctx.lineCap = 'round';
      ctx.lineWidth = 2.6;
      ctx.strokeStyle = '#E8453C';
      ctx.stroke();

      const taglineLines = wrapLines(tagline, 22, 2);

      ctx.textAlign = 'right';
      ctx.fillStyle = accent;
      ctx.font = '700 24px Inter, Arial, sans-serif';
      ctx.fillText(number, cardX + cardW - 15, cardY + 32);

      ctx.textAlign = 'center';
      ctx.fillStyle = '#111111';
      ctx.font = '700 92px Georgia, "Times New Roman", serif';
      ctx.fillText(symbol, cardCenterX, cardY + 146);

      ctx.font = '500 16px Inter, Arial, sans-serif';
      ctx.fillStyle = '#444444';
      taglineLines.forEach((line, index) => {
        ctx.fillText(line, cardCenterX, cardY + 214 + index * 19);
      });

      await drawBrandMark(ctx, cardCenterX, cardY + cardH - 55, '#E8453C');

      const compositeSrc = canvas.toDataURL('image/png');
      compositeCache.set(cacheKey, compositeSrc);
      return compositeSrc;
    };

    const parseConcept = () => {
      const value = conceptField.value.trim();

      if (!value) {
        return null;
      }

      const pieces = value.split(' | ');

      if (pieces.length < 3) {
        return null;
      }

      const number = pieces[0].trim();
      const symbol = pieces[1].trim();
      const tail = pieces.slice(2).join(' | ').trim();
      const separator = ' — ';
      const splitIndex = tail.indexOf(separator);

      return {
        number,
        symbol,
        name: splitIndex >= 0 ? tail.slice(0, splitIndex).trim() : tail,
        tagline: splitIndex >= 0 ? tail.slice(splitIndex + separator.length).trim() : '',
        label: `${number} · ${symbol}`,
      };
    };

    const syncCustomMode = () => {
      const hasCustomNotes = briefField.value.trim().length > 0;
      const standardCta = root.dataset.customStandardCta || button.textContent.trim();
      const activeCta = root.dataset.customActiveCta || standardCta;
      const standardStatus = root.dataset.customStandardStatus || status.textContent.trim();
      const activeStatus = root.dataset.customActiveStatus || standardStatus;
      const standardNote = root.dataset.customStandardNote || checkoutNote.textContent.trim();
      const activeNote = root.dataset.customActiveNote || standardNote;
      const standardWorkflow = root.dataset.customStandardWorkflow || workflowField.value;
      const activeWorkflow = root.dataset.customActiveWorkflow || standardWorkflow;

      root.dataset.customMode = hasCustomNotes ? 'true' : 'false';
      button.textContent = hasCustomNotes ? activeCta : standardCta;
      status.textContent = hasCustomNotes ? activeStatus : standardStatus;
      checkoutNote.textContent = hasCustomNotes ? activeNote : standardNote;
      workflowField.value = hasCustomNotes ? activeWorkflow : standardWorkflow;

      if (customCard) {
        customCard.dataset.active = hasCustomNotes ? 'true' : 'false';
      }
    };

    const syncPreview = async () => {
      const renderToken = ++previewRenderToken;
      const concept = parseConcept();
      const customBrief = briefField.value.trim();
      const hasCustomNotes = customBrief.length > 0;
      const hasConcept = Boolean(concept);
      const paletteIndex = concept ? (Number.parseInt(concept.number, 10) - 1) % palette.length : 0;
      const theme = palette[(paletteIndex + palette.length) % palette.length];
      const conceptNumber = hasConcept ? concept.number : '';
      const conceptSymbol = hasConcept ? concept.symbol : '';
      const titleText = concept
        ? concept.name
        : hasCustomNotes
          ? truncate(customBrief, 28)
          : previewDefaults.title;
      const descriptionText = concept
        ? concept.tagline || previewDefaults.description
        : hasCustomNotes
          ? truncate(customBrief, 70)
          : previewDefaults.description;
      const conceptPillText = concept ? concept.label : previewDefaults.conceptPill;
      const brandPillText = hasCustomNotes ? truncate(customBrief, 24) : previewDefaults.brandPill;
      const metaText = hasCustomNotes
        ? root.dataset.previewCustomMeta || previewDefaults.meta
        : concept
          ? root.dataset.previewSelectedMeta || previewDefaults.meta
          : previewDefaults.meta;
      const isHydrogenDefault = Boolean(
        hasConcept &&
          concept.number === '01' &&
          concept.symbol === 'H' &&
          !hasCustomNotes
      );
      const useHydrogenMockup = isHydrogenDefault && hydrogenPreviewSrc;
      root.style.setProperty('--bb-preview-accent', theme.accent);
      root.style.setProperty('--bb-preview-glow', theme.glow);
      root.dataset.previewMode = useHydrogenMockup ? 'hydrogen' : hasConcept || hasCustomNotes ? 'dynamic' : 'blank';
      previewArt.hidden = true;
      previewArt.src = '';
      previewArt.alt = '';
      if (useHydrogenMockup) {
        previewImage.removeAttribute('srcset');
        previewImage.removeAttribute('sizes');
        previewImage.src = hydrogenPreviewSrc;
        previewImage.alt = `${titleText} premium mockup`;
      } else {
        previewImage.removeAttribute('srcset');
        previewImage.removeAttribute('sizes');
        previewImage.src = genericPreviewSrc || basePreviewSrc;
        previewImage.alt = `${titleText} preview`;
      }
      previewTitle.textContent = titleText;
      previewDescription.textContent = descriptionText;
      previewMeta.textContent = metaText;
      previewConceptPill.textContent = conceptPillText;
      previewBrandPill.textContent = brandPillText;
      previewSummary.textContent = `${titleText}. ${descriptionText}. ${conceptPillText}. ${brandPillText}. ${metaText}.`;

      if (!hasConcept && !hasCustomNotes) {
        return;
      }

      if (useHydrogenMockup) {
        return;
      }

      try {
        const compositeSrc = await renderCompositeMockup({
          number: conceptNumber || '01',
          symbol: conceptSymbol || 'H',
          title: titleText,
          tagline: descriptionText,
          brandPill: brandPillText,
          accent: theme.accent,
          glow: theme.glow,
        });

        if (renderToken !== previewRenderToken || !compositeSrc) {
          return;
        }

        previewImage.src = compositeSrc;
        previewImage.alt = `${titleText} premium mockup`;
      } catch (error) {
        if (renderToken !== previewRenderToken) {
          return;
        }

        previewArt.hidden = false;
        previewArt.src = buildPreviewGraphic({
          number: conceptNumber || '01',
          symbol: conceptSymbol || 'H',
          title: titleText,
          tagline: descriptionText,
          brandPill: brandPillText,
          accent: theme.accent,
          glow: theme.glow,
        });
        previewArt.alt = `${titleText} preview with ${conceptPillText} and ${brandPillText}`;
      }
    };

    const syncState = () => {
      syncCustomMode();
      void syncPreview();
    };

    syncState();
    conceptField.addEventListener('change', syncState);
    briefField.addEventListener('input', syncState);
    briefField.addEventListener('change', syncState);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
